import React, { Component } from "react";
import Strings from "@my-dld/assets/strings";
import TextInputField from "../Form/TextInputField";
import { FixedMobileInput } from "../FixedEidInput";
import { RVSLookUp } from "@eres/rvsapi/entities";
import PickerInput from "../Form/PickerInput";
import { I8N, LocaleUtil } from "@eres/core";
import * as SSO from "@10x/sso";
import { isEmailAddress, isEmptyStringOrNull, normaliseMobileNumber } from "@eres/core/dist/StringUtils";

interface Props {
	claimantTypes: RVSLookUp[];
}

export interface ComplainantDetailsState {
	complainerName?: string;
	complainerMobile?: string;
	complainerEmail?: string;
	claimantType?: RVSLookUp;
}

interface State extends ComplainantDetailsState {
	claimantTypes: RVSLookUp[];
	error: { [ k: string ]: string };
}

class ComplainantDetails extends Component<Props, State> {
	private static CLAIMANT_OWNER = 2;

	constructor( props: Props ) {
		super( props );
		const name = SSO.getName();
		const mobile = SSO.getMobileNumber();
		this.state = {
			complainerName: name ? LocaleUtil.getLocalValue( name ) : "",
			complainerMobile: mobile ? normaliseMobileNumber( mobile ) : "",
			complainerEmail: SSO.getEmail(),
			claimantTypes: props.claimantTypes,
			error: {},
		};
	}

	UNSAFE_componentWillReceiveProps( nextProps: Readonly<Props>, nextContext: any ) {
		if ( nextProps ) {
			const types: RVSLookUp[] = nextProps.claimantTypes;
			this.setState( {
				claimantTypes: types,
				claimantType: types.find( ( type: RVSLookUp ) => type.ID === ComplainantDetails.CLAIMANT_OWNER ),
			} );
		}
	}

	render() {
		const { error, claimantTypes } = this.state;
		return <div className="card" id="ComplainantDetails">
			<div className="card-header">
				<span>{ "1 - " + Strings.complainant_details }</span>
			</div>
			<div className="card-body">
				<div className="row">
					<div className="col-md-12">
						<div className="mandatory-field-info">
							<small>{ Strings.mandatory_fields_note }</small>
						</div>
					</div>
					<div className="col-md-6">
						<TextInputField
							id={ "complainerName" }
							holder={ this }
							required={ true }
							label={ Strings.complainer_name }
							error={ error.complainerName }
							containerClassName={ "form-group field-style" }
							disabled={ true }/>
					</div>
					<div className="col-md-6">
						<FixedMobileInput
							id={ "complainerMobile" }
							holder={ this }
							required={ true }
							label={ Strings.Mobile_text }
							error={ error.complainerMobile }
							containerClassName={ "form-group field-style" }
							disabled={ true }/>
					</div>
					<div className="col-md-6">
						<TextInputField
							id={ "complainerEmail" }
							holder={ this }
							required={ true }
							label={ Strings.email }
							error={ error.complainerEmail }
							containerClassName={ "form-group field-style" }
							disabled={ true }/>
					</div>
					<div className="col-md-6">
						<PickerInput
							id={ "claimantType" }
							holder={ this }
							required={ true }
							label={ Strings.claimant_type }
							items={ claimantTypes }
							formatter={ ( item: RVSLookUp ) => I8N.isRTL() ? item.NameAr : item.NameEn }
							toIdentifier={ ( item: RVSLookUp ) => item.ID + "" }
							error={ error.claimantType }
							disabled={ true }/>
					</div>
				</div>
			</div>
		</div>;
	}

	public isValid(): Promise<ComplainantDetailsState> {
		let isValid = true;
		const { complainerName, complainerMobile, complainerEmail, claimantType } = this.state;
		const error: { [ k: string ]: string } = {};
		if ( isEmptyStringOrNull( complainerName ) ) {
			error.complainerName = Strings.required;
			isValid = false;
		}
		let mobile = complainerMobile ? normaliseMobileNumber( complainerMobile ) : "";
		if ( isEmptyStringOrNull( mobile ) || ( mobile && mobile.length !== 12 ) ) {
			error.complainerMobile = Strings.required;
			isValid = false;
		}
		if ( isEmptyStringOrNull( complainerEmail ) || ( complainerEmail && !isEmailAddress( complainerEmail ) ) ) {
			error.complainerEmail = Strings.required;
			isValid = false;
		}
		if ( claimantType == undefined ) {
			error.claimantType = Strings.required;
			isValid = false;
		}
		this.setState( {
			error: error,
		} );
		if ( isValid ) {
			return Promise.resolve( this.state );
		}
		return Promise.reject( "ComplainantDetails not Valid" );
	}
}

export default ComplainantDetails;
